import { render, staticRenderFns } from "./ConfigurationView.vue?vue&type=template&id=66a1ae54&"
import script from "./ConfigurationView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationView.vue?vue&type=style&index=0&id=66a1ae54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports